import { createLogic } from "redux-logic";
import { actions } from "./actions";
import {GET_LOGIN_SAML, GET_LOGOUT_SAML, POST_LOGIN} from "../../services/authentication/services";
import {parseToken, sessionSaveData, tokenRolesField, tokenUsernameField
} from "../../services/session-storage-management/session-storage-management";

const Login = createLogic({
  type: 'AUTHORIZATION_REQUEST',
  latest: true,

  process({ getState, action }, dispatch, done) {
    POST_LOGIN({ password: action.password, username: action.username })
      .then(resp => {

        sessionSaveData(JSON.stringify(parseToken(resp.data.token, tokenRolesField)), tokenRolesField);
        sessionSaveData(action.username, tokenUsernameField);

        dispatch({
          type: [actions.AUTHORIZATION_SUCCESS],
          token: resp.data.token,
          roles: parseToken(resp.data.token)['roles'],
          username: action.username,
          loggedIn: true
        })
      }
      )
      .catch(err => {
        dispatch({
          type: [actions.AUTHORIZATION_ERROR],
          token: null,
          username: null,
          loggedIn: false
        });
      })
      .then(() => done());
  },
});

const SAMLLogin = createLogic({
  type: 'AUTHORIZATION_SAML_REQUEST',
  latest: true,

  process({ getState, action }, dispatch, done) {
    GET_LOGIN_SAML()
        .then(resp => {

            sessionSaveData(JSON.stringify(parseToken(resp.data.token, tokenRolesField)), tokenRolesField);
            sessionSaveData(JSON.stringify(parseToken(resp.data.token, tokenUsernameField)), tokenUsernameField);

            dispatch({
                type: [actions.AUTHORIZATION_SUCCESS],
                token: resp.data.token,
                roles: parseToken(resp.data.token)['roles'],
                username: parseToken(resp.data.token)['sub'],
                loggedIn: true
            });

            // localStorage.setItem("Username", parseJwt(resp.data.token)['sub'])
            }
        )
        .catch(err => {
          dispatch({
            type: [actions.AUTHORIZATION_ERROR],
            token: null,
            username: null,
            loggedIn: false
          });
        })
        .then(() => done());
  },
});

const SAMLLogout = createLogic({
    type: 'LOGOUT_SAML_REQUEST',
    latest: true,

    process({getState, action}, dispatch, done) {
        GET_LOGOUT_SAML()
            .then(resp => {
                    this.props.dispatch({
                        type: [actions.AUTHORIZATION_ERROR],
                        token: null,
                        username: null,
                        loggedIn: false
                    });

                    window.location.reload();
                    this.props.history.push("/login");
                }
            )
            .catch(err => {
            })
            .then(() => {
                done()
            });
    },
});

export default [Login, SAMLLogin, SAMLLogout];
